export const ACCOUNT_QUERY_KEY = ["accounts"];

export const ACCOUNT_PAGE_SIZE_OPTIONS = ["10", "20", "50"];
export const DEFAULT_ACCOUNT_PAGE_SIZE = 10;

export const ACCOUNT_STATUS_OPTIONS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];
